import { useLocation, useNavigate } from 'react-router-dom';

import { useStores } from 'mobx/hooks/useStores';

export function useToggleCallLog(open: () => void) {
  const { callLoggingStore } = useStores();

  return () => {
    if (callLoggingStore.isOpenAndMinimized) {
      callLoggingStore.toggleMinimize();
    } else {
      open();
    }
  };
}

export function useToggleCallLogWithNav(patientId: number) {
  const navigate = useNavigate();
  const location = useLocation();
  const { callLoggingStore } = useStores();
  const toggleCallLog = useToggleCallLog(callLoggingStore.startCallSession);

  return () => {
    const patientPath = `/patient/${patientId}`;
    if (!location.pathname.includes(patientPath)) {
      navigate(patientPath);
    }
    toggleCallLog();
  };
}
